import React, { Component } from 'react';
import { NavMenuSimple } from '../Nav/NavMenuSimple';

import { Container, Row, Col} from 'react-bootstrap';

import { Outlet } from 'react-router-dom';
import styles from './LayoutAuth.module.scss'

export class LayoutAuth extends Component {
  static displayName = LayoutAuth.name;

  render() {
    return (
      <>        
        <div className={`${styles.root}`}>
          <div className={styles.header}>
            <NavMenuSimple />
          </div>
          <Container fluid="xl" className={`${styles.main} h-100`}>
            <Row className="h-100">
              <Col sm={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }} className="mt-auto mb-auto" >
                <main>
                  <div className={styles.authBox}>
                    <Outlet />
                  </div>
                </main>
              </Col>
            </Row>
            </Container>
        </div>
      </>
    );
  }
}
